import { SECONDARY, makeThemeColor } from '@tornado-rdk/theme';

export const color = makeThemeColor(SECONDARY);

export const getSpinnerContainerAnimation = () => ({
  duration: 15,
  repeat: -1,
  stopMethod: 'immediate',
  actions: [
    {
      p: 'rotation',
      v: {
        0: { v: 0, sm: 0 },
        1: { v: Math.PI * 2, sm: 0 },
      },
    },
  ],
});
